import { Col, Row, Skeleton } from 'antd';
import { MyTag } from 'components/Atoms';
import { ArrowOutLeftIcon } from 'components/Atoms/Icon';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import './styles.scss';
import useBreadcrumb from 'hooks/useBreadcrumb';
import { isMobile } from 'utilities/common';

const MyPageHeader = ({
  showBreadcrumb = true,
  title,
  subtitle,
  customSubtitle,
  showTag = false,
  tagStatus,
  tagContent,
  backLink,
  customAction,
  loading = false,
  className,
}) => {
  const { breadcrumbs } = useBreadcrumb();

  // TODO: un-comment breadcrumb when handle all new layout, or else breadcrumb is duplicated in page
  return (
    <div
      className={cn(
        'my-page-header',
        !showBreadcrumb && 'no-breadcrumb',
        className
      )}
    >
      {showBreadcrumb && breadcrumbs}
      <Row justify="space-between" align="middle">
        <Col>
          <Row gutter={16} align="start">
            <Col className="pt-4">
              {!!backLink && (
                <Link to={backLink}>
                  <ArrowOutLeftIcon />
                </Link>
              )}
            </Col>
            <Col className="my-page-header-title-block">
              {loading ? (
                <Skeleton.Button block size="large" className="w-200" />
              ) : (
                <>
                  <div className="flex-center-start">
                    <span className="my-page-header-title">{title}</span>
                    {showTag && (
                      <MyTag status={tagStatus} className="flex-center-start">
                        {tagContent}
                      </MyTag>
                    )}
                  </div>
                  {!!subtitle && (
                    <div className="my-page-header-subtitle">{subtitle}</div>
                  )}
                  {!!customSubtitle && <>{customSubtitle}</>}
                </>
              )}
            </Col>
          </Row>
        </Col>
        <Col>{!!customAction && <>{customAction}</>}</Col>
      </Row>
    </div>
  );
};

export default MyPageHeader;
